module.exports = {
    profile: 'Profile',
    language: 'Language',
    security: 'Security',
    privacy: 'Privacy',
    customization: 'Accessibility and Customization',
    gamification: 'Gamification',
}
